import React, { useEffect } from 'react';

import {useSelector} from 'react-redux';
import { Provider } from 'react-redux';
import { ApplicationState } from '../../store';
import './ErrorPage.css'
import {useNavigate} from 'react-router-dom';

// const history = useHistory();

const ErrorPage = () => {
    const navigate = useNavigate();
    const userIsAuthenticated = useSelector((state: ApplicationState) => state.authenticationState.authSettings?.isAuthenticated);


    useEffect(() => {
        if (!userIsAuthenticated)
        navigate('/');
    }, [])


    return (
        
        <React.Fragment>
            Oops! Something went wrong, go to the home page...
        </React.Fragment>
            

    )
}; export default ErrorPage;
